<template>
    <v-card>
    <div class="calendar-container">
      <!-- Sidebar -->
      <!-- <aside class="sidebar">
        <ul>
          <li>Descripción</li>
          <li class="active">Programa</li>
          <li>Lista de</li>
          <li>Turnos de</li>
          <li>Médicos</li>
          <li>Unidades</li>
          <li>Inventario</li>
        </ul>
        <div class="sidebar-footer">
          <p>Ajustes</p>
          <p>Centro de ayuda</p>
          <p>Desconectar</p>
        </div>
      </aside> -->
  
      <!-- Main Calendar Section -->
      <main class="main-calendar">
        <header>
          <h1>Equipo</h1>
          <div class="calendar-controls">
            <button @click="goToPreviousMonth">←</button>
            <span>{{ currentMonth }}</span>
            <button @click="goToNextMonth">→</button>
            <button class="add-new">Añadir nuevo</button>
          </div>
        </header>
  
        <!-- Calendar Grid -->
        <div class="calendar">
          <div class="day-header" v-for="day in days" :key="day">{{ day }}</div>
          <div
            v-for="day in daysInMonth"
            :key="day.date"
            class="day-cell"
            :class="{ today: day.isToday }"
          >
            <div class="date">{{ day.date }}</div>
            <div v-for="event in day.events" :key="event.time" class="event">
              <p class="time">{{ event.time }}</p>
              <p>{{ event.name }}</p>
            </div>
          </div>
        </div>
      </main>
    </div>
</v-card>
  </template>
  
  <script>
  export default {
    data() {
      return {
        currentMonth: new Date().toLocaleString("default", { month: "long" }),
        currentYear: new Date().getFullYear(),
        days: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
        events: [
          {
            date: "2025-01-08",
            time: "11:00",
            name: "Dr. Miller",
          },
          {
            date: "2025-01-13",
            time: "9:00",
            name: "Dra. Emily",
          },
        ],
      };
    },
    computed: {
      daysInMonth() {
        const date = new Date(this.currentYear, new Date().getMonth() + 1, 0);
        return Array.from({ length: date.getDate() }, (_, i) => {
          const dayDate = new Date(this.currentYear, new Date().getMonth(), i + 1);
          const dayString = dayDate.toISOString().split("T")[0];
          return {
            date: i + 1,
            isToday: dayString === new Date().toISOString().split("T")[0],
            events: this.events.filter((event) => event.date === dayString),
          };
        });
      },
    },
    methods: {
      goToPreviousMonth() {
        // Lógica para retroceder un mes
      },
      goToNextMonth() {
        // Lógica para avanzar un mes
      },
    },
  };
  </script>
  
  <style scoped>
  /* General Layout */
  .calendar-container {
    display: flex;
    font-family: Arial, sans-serif;
  }
  
  .sidebar {
    width: 20%;
    background: #f5f5f5;
    padding: 20px;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  }
  
  .sidebar ul {
    list-style: none;
    padding: 0;
  }
  
  .sidebar ul li {
    padding: 10px;
    cursor: pointer;
  }
  
  .sidebar ul li.active {
    background: #d0e8ff;
  }
  
  .sidebar-footer {
    margin-top: 20px;
    font-size: 14px;
  }
  
  /* Calendar */
  .main-calendar {
    flex-grow: 1;
    padding: 20px;
  }
  
  .main-calendar header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
  }
  
  .calendar-controls {
    display: flex;
    gap: 10px;
    align-items: center;
  }
  
  .calendar-controls button {
    border: none;
    background: #d0e8ff;
    padding: 5px 10px;
    cursor: pointer;
  }
  
  .calendar {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: 5px;
  }
  
  .day-header {
    font-weight: bold;
    text-align: center;
  }
  
  .day-cell {
    border: 1px solid #ddd;
    padding: 10px;
    position: relative;
  }
  
  .day-cell.today {
    background: #f0f8ff;
  }
  
  .event {
    background: #d0e8ff;
    margin: 5px 0;
    padding: 5px;
    border-radius: 5px;
  }
  
  .event .time {
    font-size: 12px;
    font-weight: bold;
  }
  </style>